import { useInstance } from '@meraki-internal/react-dependency-injection';
import { useState } from 'react';
import { CareMapState } from '../caremap/CareMapState';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { useToast } from '../components/useToast';
import { MenuItem } from '../components/MenuItem';
import { DownloadIcon } from '../theme/Icons';

export const DownloadCaremapMenuItem: React.FC = () => {
    const [downloading, setDownloading] = useState(false);
    const careMapState = useInstance(CareMapState);
    const tracking = useInstance(MixPanelEventEmitter);

    const [present] = useToast();

    const download = async () => {
        setDownloading(true);
        try {
            await careMapState.download();
            tracking.track('Care Map Downloaded');
        } catch (e) {
            present({ duration: 3000, message: 'Sorry, we were unable to download your Care Map, please try again.' });
        } finally {
            setDownloading(false);
        }
    };
    return (
        <MenuItem
            disabled={downloading}
            onClick={download}
            label="Download Care Map"
            Icon={DownloadIcon}
        />
    );
};
